import { ChangeDetectionStrategy, Component, Signal, inject } from '@angular/core';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { HdPhsActivationInfoComponent } from './hd-phs-activation-info.component';
import { HdPhsActivationInfoContext } from './hd-phs-activation-info-context.model';

/**
 * Floating-panel-wrapper voor {@link HdPhsActivationInfoComponent}. Wordt door
 * {@link FloatingPanelService} dynamisch gemount; leest de via DI doorgegeven
 * `FLOATING_PANEL_DATA`-signal en geeft het door als input aan de content-
 * component.
 *
 * De content-component zelf blijft herbruikbaar buiten een floating-panel
 * context (analoog aan {@link HdCircuitInfoPanelComponent}).
 */
@Component({
  selector: 'hd-phs-activation-info-panel',
  template: `<hd-phs-activation-info [context]="data()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdPhsActivationInfoComponent],
})
export class HdPhsActivationInfoPanelComponent {
  protected readonly data = inject(FLOATING_PANEL_DATA) as Signal<HdPhsActivationInfoContext>;
}
